
/* MODEL */
export const GET_MODEL_LISTING = "GET_MODEL_LISTING";
export const GET_MODEL_LISTING_SUCCESS = "GET_MODEL_LISTING_SUCCESS";
export const GET_MODEL_LISTING_FAIL = "GET_MODEL_LISTING_FAIL";

export const GET_MODEL_DETAILS = "GET_MODEL_DETAILS";
export const GET_MODEL_DETAILS_SUCCESS = "GET_MODEL_DETAILS_SUCCESS";
export const GET_MODEL_DETAILS_FAIL = "GET_MODEL_DETAILS_FAIL";

export const ADD_MODEL = "ADD_MODEL";
export const ADD_MODEL_SUCCESS = "ADD_MODEL_SUCCESS";
export const ADD_MODEL_FAIL = "ADD_MODEL_FAIL";

export const UPDATE_MODEL = "UPDATE_MODEL";
export const UPDATE_MODEL_SUCCESS = "UPDATE_MODEL_SUCCESS";
export const UPDATE_MODEL_FAIL = "UPDATE_MODEL_FAIL";

export const DELETE_MODEL = "DELETE_MODEL";
export const DELETE_MODEL_SUCCESS = "DELETE_MODEL_SUCCESS";
export const DELETE_MODEL_FAIL = "DELETE_MODEL_FAIL";

export const EXPORT_MODEL = "EXPORT_MODEL";
export const EXPORT_MODEL_SUCCESS = "EXPORT_MODEL_SUCCESS";
export const EXPORT_MODEL_FAIL = "EXPORT_MODEL_FAIL";

export const RESET_MODEL_STATE = 'RESET_MODEL_STATE';
export const RESET_MODEL_ATTACHMENT_STATE = 'RESET_MODEL_ATTACHMENT_STATE';